
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import ContainerBox from 'layouts/UIElements/ContainerBox/ContainerBox';
import Button from "react-bootstrap/Button";
import { withRouter } from 'helpers/ModuleHelper';
import { Flow } from 'flow-react';
import { observer } from 'mobx-react';
import * as actions from 'store/actions';
import { injectIntl } from 'react-intl';
import * as ConfigTypes from 'config/ConfigTypes';
import { getMetaConfig } from "helpers/ConfigHelper";
import * as fieldHelper from "helpers/FieldHelper";
import { getThumbUrl, getImgUrl } from "helpers/ImageHelper";
import { onFullScreenClick } from "helpers/PageHelper";
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { getMediaTypeObj, getDefaultImg } from 'helpers/FileHelper';
import { handleCalDoneClick } from "helpers/CartHelper";
import * as CartHelper from "helpers/CartHelper";
import { canShow } from "helpers/CalendarHelper";
import { isHome, pubPath } from 'helpers/AppHelper';
import { handleNext } from "helpers/DetailHelper";
import UICalendar from "components/UI/Calendar/Calendar";
import UIMultiCalendar from "components/UI/MultiCalendar/MultiCalendar";
import TvPlayer from 'components/UI/TvPlayer/TvPlayer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faCartShopping }
    from "@fortawesome/free-solid-svg-icons";
import './ItemDetail.scss';


const ItemDetail = observer(
    class ItemDetail extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                currentClip: { title: '' },
                viewMode: ConfigTypes.ITEM_DETAIL,
                mediaUrl: "",
                fullMediaUrl: ""
            }
        }

        fm = ({ id }) => this.props.intl.formatMessage({ id });

        updateClip = () => {
            const { currentClip } = this.props.mediaObjects;
            if (currentClip) {
                console.log("LOGS: currentClip", currentClip);
                this.setState({ currentClip: currentClip, loading: true }, () => {
                    let elements;
                    if (currentClip && currentClip.mediafiles && currentClip.mediafiles.elements) {
                        elements = currentClip.mediafiles.elements;
                    }
                    let mediaTypeObj = getMediaTypeObj({ elements, clip: currentClip });
                    console.log("LOGS: showCustomMedia mediaTypeObj", mediaTypeObj);
                    if (mediaTypeObj) {
                        this.setState({ mediaUrl: mediaTypeObj.mediaUrl, mediaTypeObj, loading: false });
                    }
                });
            }
        }

        formatMessage = ({ id }) => {
            return this.props.intl.formatMessage({ id });
        }

        onMediaFileClick = (item) => () => {
            if (item && item.path && item.filename) {
                let mediaUrl = getThumbUrl({ item });
                let fullMediaUrl = getThumbUrl({ item, fullScreen: true });
                this.setState({ mediaUrl, fullMediaUrl });
            }
        }

        showMediafiles = () => {
            const { currentClip } = this.props.mediaObjects;
            if (currentClip && currentClip.mediafiles
                && currentClip.mediafiles.elements && currentClip.mediafiles.elements.length > 1)
                return (
                    <div className="col-lg-7 col-md-9 col-sm-12 mx-auto itemdetail-mediafile-box">
                        {currentClip.mediafiles.elements.map((item, index) => {
                            return (
                                <div className="itemdetail-mediafile-img" key={`mediafile_${index}`}>
                                    <img className="img-responsive img-rounded"
                                        onClick={this.onMediaFileClick(item)} src={item.url} alt="" />
                                </div>)
                        })}
                    </div>)
        }

        showClipMedia = () => {
            let elementId = "clipDetailImage";
            let fullSrc = getImgUrl({ fullScreen: true, stateCurrentClip: this.state.currentClip });
            if (this.state.fullMediaUrl) fullSrc = this.state.fullMediaUrl;
            return (
                <div className="col-lg-7 col-md-9 col-sm-10 col-xs-12 mx-auto">
                    <div className="itemdetail-media-wrapper">
                        <img className="itemdetail-media" src={this.state.mediaUrl}
                            onClick={onFullScreenClick(elementId, fullSrc)} id={elementId} />
                    </div>
                </div>)
        }

        showClipContent = ({ showFields }) => {
            return (
                <Fragment>
                    <div className="itemdetail-content">
                        {showFields.map((el, i) => {
                            if (el[`${this.state.viewMode}group`]) {
                                if (el[`${this.state.viewMode}group`].isFirst) {
                                    return fieldHelper.showElementMetaBox({
                                        el, i, isGroup: true, formatMessage: this.formatMessage,
                                        viewMode: this.state.viewMode, element: this.state.currentClip
                                    });
                                }
                                return <span key={`itemdetailHeading${i}`}></span>
                            }
                            if (el[`${this.state.viewMode}Html`]) {
                                return (
                                    <h1 className="itemdetail-heading" key={`itemdetailHeading${i}`}>
                                        {this.state.currentClip.metadata.fields[el.field] || ''}
                                    </h1>)
                            }
                            return fieldHelper.showElementMetaBox({
                                el, i, viewMode: this.state.viewMode,
                                element: this.state.currentClip, formatMessage: this.formatMessage
                            });
                        })}
                    </div>
                </Fragment>
            )
        }

        onLeftMenuClick = (item) => () => {
            if (item.name === ConfigTypes.OVERVIEW) {
                this.props.updateMediaObjects({ keyword: "", viewMode: ConfigTypes.HOME, currentPage: 1 });
                if (!isHome()) this.props.router.navigate("/");
            }
        }

        onBackClick = () => {
            const { currentWork } = this.props.mediaObjects;
            if (currentWork) {
                this.props.updateMediaObjects({
                    viewMode: ConfigTypes.WORK_DETAIL,
                    toTop: true, wpView: ConfigTypes.WORK_LIST
                });
                this.props.router.navigate(`${ConfigTypes.WORK_PATH}/${currentWork.id}`);
            }
        }

        getPrevNext = (isNext = true) => {
            const { itemlist, currentClip } = this.props.mediaObjects;
            if (itemlist && itemlist.length) {
                const obj = handleNext({ list: itemlist, current: currentClip, isNext });
                if (obj) {
                    this.props.updateMediaObjects({ viewMode: ConfigTypes.ITEM_DETAIL, toTop: true, currentClip: obj.nextObj });
                    this.props.router.navigate(`${ConfigTypes.ITEM_PATH}/${obj.nextId}`);
                }
            }
        }

        onNextClick = () => {
            this.getPrevNext();
        }

        onPrevClick = () => {
            this.getPrevNext(false);
        }

        showLeftMenu = () => {
            return (
                <div className="itemdetail-leftmenu-box">
                    {ConfigTypes.CLIPDETAIL_LEFTMENU.map(item => {
                        return (
                            <div className="itemdetail-leftmenu-item" onClick={this.onLeftMenuClick(item)}>
                                {this.props.intl.formatMessage({ id: item.intl })}
                            </div>
                        )
                    })}
                </div>
            )
        }

        showImage = ({ isDefault }) => {
            let elementId = "itemDetailImage";
            let fullSrc = getImgUrl({ fullScreen: true, stateCurrentClip: this.state.currentClip });
            if (this.state.fullMediaUrl) fullSrc = this.state.fullMediaUrl;
            let imgUrl;
            if (this.state.mediaTypeObj && this.state.mediaTypeObj.mediaUrl) {
                imgUrl = this.state.mediaTypeObj.mediaUrl;
            }
            if (isDefault) {
                imgUrl = getDefaultImg();
                fullSrc = imgUrl;
            }
            return (
                <div className="itemdetail-img-box">
                    {isDefault && (<div className="itemdetail-img-overlay"></div>)}
                    {<img className="itemdetail-media" src={imgUrl}
                        onClick={onFullScreenClick(elementId, fullSrc)} id={elementId} />}
                </div>)
        }

        showCustomMedia = () => {
            if ((!this.state.loading && this.state.currentClip && !this.props.mediaObjects.loading)
                || this.props.mediaObjects.openVideoPlayer) {
                if (this.state.mediaTypeObj && this.state.mediaTypeObj.type === ConfigTypes.VIDEO) {
                    return (
                        <div className="itemdetail-media-box"><VideoPlayer /></div>
                        // <div className="itemdetail-tvplayer">
                        //     <TvPlayer src={this.state.mediaTypeObj.mediaUrl} />
                        // </div>
                    )
                }
                if (this.state.mediaTypeObj && this.state.mediaTypeObj.type === ConfigTypes.IMAGE) {
                    return this.showImage({});
                }
                return this.showImage({ isDefault: true });
            }
        }

        showContent = ({ showFields, isDesc = false, isHeading = false, isWork }) => {
            if (showFields && showFields.length) {
                const { currentClip, currentWork } = this.props.mediaObjects;
                let element = currentClip;
                if (isWork) element = currentWork;
                return showFields.map((item, i) => {
                    let isGroup = item[`${this.state.viewMode}group`];
                    let filterType = item[`${this.state.viewMode}filterType`] || false;
                    return fieldHelper.showElementMetaBox({
                        el: item, i, viewMode: this.state.viewMode,
                        element, formatMessage: this.formatMessage,
                        boxClass: "itemdetail-content-box", isGroup,
                        labelClass: "itemdetail-label", txtClass: "itemdetail-content",
                        filterType
                    });
                })
            }
        }

        //CART BEGIN
        onBtnOkClick = ({ item, dates }) => {
            handleCalDoneClick({ item, fm: this.fm, props: this.props, dates });
        };


        showCalendarBox = () => {
            const { currentClip } = this.props.mediaObjects;
            const { isLoggedIn } = this.props.authObjects;
            if ((ConfigTypes.SHOW_CART && isLoggedIn
                && canShow({ item: currentClip, props: this.props }))) {
                return (
                    <div className="listitem-item listitem-action bg-transparent">
                        <UIMultiCalendar formatMessage={this.props.intl.formatMessage} onBtnChooseClick={() => { }}
                            btnOkId="calendar.done" btnChooseId="calendar.choose"
                            onDateAction={this.onBtnOkClick} item={currentClip} cartObjects={this.props.cartObjects}
                            onBtnOkClick={() => { }} onCalendarClick={() => { }} />
                    </div>
                )
            }
            return null;
        }
        //CART END

        showLongDetails = () => {
            const { currentWork } = this.props.mediaObjects;
            const workFields = getMetaConfig({
                viewMode: ConfigTypes.ITEM_DETAIL, props: this.props, configName: ConfigTypes.WORK
            });
            const showFields = getMetaConfig({
                viewMode: ConfigTypes.ITEM_DETAIL,
                props: this.props, configName: ConfigTypes.ITEM
            })
            return (
                <div>
                    <div className="itemdetail-workpart">
                        {currentWork && this.showContent({ showFields: workFields, isWork: true })}
                    </div>
                    <div>
                        {this.showContent({ showFields })}
                    </div>
                </div>)
        }

        showBackNextBtn = () => {
            return (
                <div className="itemdetail-navbtns">
                    <div className="itemdetail-calendar"> {this.showCalendarBox()}</div>
                    <div className="itemdetail-back" onClick={this.onBackClick}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        {this.props.intl.formatMessage({ id: "itemdetail.showback" })}
                    </div>
                    <div className="itemdetail-next" onClick={this.onPrevClick}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        {this.props.intl.formatMessage({ id: "itemdetail.showprev" })}
                    </div>
                    <div className="itemdetail-next" onClick={this.onNextClick}>
                        {this.props.intl.formatMessage({ id: "itemdetail.shownext" })}
                        <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                </div>)
        }

        showFooter = () => {
            return (
                <div className="itemdetail-footer-box">
                    <div></div>
                    {/* {this.showBackNextBtn()} */}
                </div>
            )
        }

        showItemDetail = () => {
            if (this.state.currentClip && this.state.currentClip.metadata
                && this.state.currentClip.metadata.fields && !this.state.loading) {
                return (
                    <div className="itemdetail-page">
                        {this.showBackNextBtn()}
                        <div className="itemdetail-container">
                            <div className="itemdetail-top">
                                {/* {this.showBackNextBtn()} */}
                            </div>
                            <div className="itemdetail-left">
                                {this.showCustomMedia()}
                            </div>
                            <div className="itemdetail-right">
                                {this.showLongDetails()}
                            </div>
                            <div className="itemdetail-bottom">
                                {/* {this.showLongDetails()} */}
                            </div>
                        </div>
                    </div>
                )
            }
        }

        componentDidUpdate(prev) {
            if (prev.mediaObjects.currentClip != this.props.mediaObjects.currentClip) {
                this.updateClip();
            }
        }

        componentDidMount() {
            this.updateClip();
        }

        render() {
            return (
                <ContainerBox>
                    <div className="itemdetail">
                        {this.showItemDetail()}
                    </div>
                </ContainerBox>)
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    configObjects: state.config.configObjects,
    cartObjects: state.cart.cartObjects,
    authObjects: state.auth.authObjects,
});

const mapDispatchToProps = (dispatch) => ({
    updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj)),
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    addToFeCart: (obj) => dispatch(actions.addToFeCart(obj))
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(ItemDetail))));